<template>
  <flex
    class="main-head"
    align="center"
    justify="between"
  >
    <flex
      align="center"
      class="head-img"
      @click="toHome"
    >
      <img src="@/static/img/logo.png">
      <span>{{ dataBase }}</span>
    </flex>
    <!-- <flex
      justify="around"
      class="menu_list">`
      <div
        v-for="(item, index) in menuList"
        :key="index"
        :class="{'checked' : item.url === $route.path}"
        class="menu-item"
        @click="toUrl(item)">
        {{ item.name }}
        <div class="item-line"/>
      </div>
    </flex> -->
    <flex>
      <!-- <flex
        v-if="level === 1"
        align="center"
        justify="center"
        class="base-button location">
        <img src="@/static/img/location-base.png">
        <span style="margin: 0px 10px;">地方库</span>
        <img src="@/static/img/location-arrow.png">
      </flex> -->
      <flex
        align="center"
        justify="center"
        class="base-button open"
        @click="toOpenPlatform"
      >
        <img src="@/static/img/application.png">
        <span style="margin-left: 10px;">开放平台</span>

      </flex>
      <flex
        align="center"
        style="margin-left: 30px;"
      >
        <span>{{ realname }}</span>
        <el-button
          type="danger"
          size="small"
          style="margin-left: 20px;"
          round
          @click.stop.native="loginOutSys()"
        >退出登录</el-button>
      </flex>
    </flex>
  </flex>
</template>

<script>
import { mapGetters } from 'vuex'
import * as api from '@/api/index'
export default {
  data () {
    return {
      // menuList: ['首页', '搜索', '大事记', '扶贫印记', '我的扶贫故事', '领导关怀', '全省数据库集群']
      menuList: [
        {
          name: '首页',
          url: '/home'
        },
        {
          name: '我的扶贫故事/我的脱贫故事',
          url: '/list',
          data: '扶贫印记'
        },
        {
          name: '扶贫印记',
          url: '/list',
          data: '扶贫印记'
        },
        {
          name: '大事记',
          url: '/list',
          data: '扶贫印记'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['openUrl', 'dataBase']),
    level () {
      return this.$route.query.level ? Number(this.$route.query.level) : 1
    },
    realname () {
      return localStorage.getItem('realname')
    }
    // dataBase () {
    //   if (this.$route.query.database) {
    //     if (this.$route.query.database === '贵州省数据库') {
    //       return '贵州数据库'
    //     } else {
    //       return this.$route.query.database
    //     }
    //   } else {
    //     return '贵州数据库'
    //   }
    // }
  },
  methods: {
    toUrl (item) {
      if (item.url) {
        if (item.url === '/home') {
          this.$router.replace({
            path: item.url,
            query: {
              ...this.$options.filters.keepURLParams(this)
            }
          })
        } else {
          let routerData = this.$router.resolve({
            path: item.url,
            query: {
              ...this.$options.filters.keepURLParams(this),
              listCatalogName: item.name
            }
          })
          window.open(routerData.href, '_blank')
        }
      } else {
        window.open('', '_blank')
      }
    },
    // 回到搜索首页
    toHome () {
      this.$router.replace({
        path: '/home',
        query: {
          ...this.$options.filters.keepURLParams(this)
        }
      })
    },
    toOpenPlatform () {
      window.open(this.openUrl, '_blank')
    },
    loginOutSys () {
      let token = localStorage.getItem('token')
      api.loginoutsys(token).then(res => {
        if (res.data) {
          this.$emit('loginoutsuccess')
          this.$router.push({
            path: '/login'
          })
          localStorage.removeItem('token')
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.main-head
  position fixed
  top 0px
  z-index 999
  width 100%
  height 66px
  // background #D60D1A
  background #fff
  box-shadow 0px 3px 8px 0px rgba(53, 53, 53, 0.21)
  padding 25px 17.5%
  box-sizing border-box
.head-img
  width 319px
  height 30px
  cursor pointer
  img
    height 100%
  span
    flex none
    background #DD3D3B
    color #fff
    letter-spacing 2px
    padding 4px 9px
    border-radius 6px
    font-size 15px
    margin-left 10px
.menu_list
  margin 0px 11.5%
  .menu-item
    position relative
    flex none
    cursor pointer
    color #333
    font-size 18px
    // font-weight bold
    &:hover
      color #C3291A
      .item-line
        width 100%
    &:not(:first-of-type)
      margin-left 46px
  .item-line
    position absolute
    top 40px
    width 0px
    height 3px
    // background #fff
    background #C3291A
    // transition width .2s ease-in-out
.base-button
  cursor pointer
  flex none
  display flex
  align-items center
  padding 10px 20px
  font-size 16px
  box-sizing border-box
  background transparent
  // box-shadow 0px 4px 10px 0px rgba(204, 139, 142, 0.1)
  border-radius 16px
  outline none
  border none
.location
  margin-right 20px
  background-image url('~@/static/img/location-bg.png')
  background-size 100% 100%
  color #F0A900
.open
  background-image url('~@/static/img/open-bg.png')
  background-size 100% 100%
  color #C3291A
</style>
